import { c as _c } from "react/compiler-runtime";
import React from "react";
import { DistributionCauseArea } from "../../../../models";
import style from "./Distribution.module.scss";
import { useCauseAreas } from "../../../../_queries";
import { useAuth0 } from "@auth0/auth0-react";
import { isAllocationVisible } from "../distributionAmounts";
export const DistributionController: React.FC<{
  causeArea: DistributionCauseArea;
  savedCauseArea?: DistributionCauseArea;
  onChange: (causeArea: DistributionCauseArea) => void;
}> = t0 => {
  const $ = _c(23);
  const {
    causeArea,
    savedCauseArea: t1,
    onChange
  } = t0;
  const savedCauseArea = t1 === undefined ? causeArea : t1;
  const {
    getAccessTokenSilently
  } = useAuth0();
  const {
    data: causeAreas,
    loading: causeArasLoading
  } = useCauseAreas(getAccessTokenSilently);
  if (causeArasLoading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div>Loading cause areas...</div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (!causeAreas?.length) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div>No cause areas found</div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== causeArea || $[3] !== causeAreas || $[4] !== onChange || $[5] !== savedCauseArea) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const currentCauseAreaOrgs = causeAreas.find(ca => ca.id === causeArea.id)?.organizations;
      if (!currentCauseAreaOrgs) {
        let t6;
        if ($[10] !== causeArea.id) {
          t6 = <div>Cause in current distribution not found (id {causeArea.id})</div>;
          $[10] = causeArea.id;
          $[11] = t6;
        } else {
          t6 = $[11];
        }
        t5 = t6;
        break bb0;
      }
      t4 = style.wrapper;
      t2 = style.grid;
      let t6;
      if ($[12] !== savedCauseArea) {
        t6 = org => isAllocationVisible(org.isActive, savedCauseArea.organizations.find(organization => organization.id === org.id)?.amount);
        $[12] = savedCauseArea;
        $[13] = t6;
      } else {
        t6 = $[13];
      }
      let t7;
      if ($[14] !== causeArea || $[15] !== onChange) {
        t7 = org_0 => <div key={org_0.id} className={style["share-wrapper"]}><span>{org_0.widgetDisplayName || org_0.name}</span><div><input type="text" value={causeArea.organizations?.find(organization_0 => organization_0.id === org_0.id)?.amount ?? 0} onChange={e => {
              const amount = Math.max(0, parseInt(e.target.value, 10) || 0);
              const organizations = [...causeArea.organizations];
              const index = organizations.findIndex(o => o.id === org_0.id);
              if (index === -1) {
                organizations.push({
                  id: org_0.id,
                  name: org_0.name,
                  percentageShare: "0",
                  amount
                });
              } else {
                organizations[index] = {
                  ...organizations[index],
                  amount
                };
              }
              onChange({
                ...causeArea,
                amount: organizations.reduce(_temp, 0),
                organizations
              });
            }} data-cy="distribution-input" /><span>kr</span></div></div>;
        $[14] = causeArea;
        $[15] = onChange;
        $[16] = t7;
      } else {
        t7 = $[16];
      }
      t3 = currentCauseAreaOrgs.filter(t6).map(t7);
    }
    $[2] = causeArea;
    $[3] = causeAreas;
    $[4] = onChange;
    $[5] = savedCauseArea;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t3) {
    t6 = <div className={t2}>{t3}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
function _temp(total, organization_1) {
  return total + (organization_1.amount ?? 0);
}